var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import searchConfigURL from "@adapters/infrastructures/urlConfig/Search/searchURL";
import { isEmpty } from "@domains/utils/validation";
import { accountDetails } from "@di";
var SearchRepository = /** @class */ (function () {
    function SearchRepository(http) {
        this.http = http;
    }
    SearchRepository.prototype.getCommFutSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, comSearch, comfut;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.comfut);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        !!req.exchangeType && url.searchParams.append("exchange", req.exchangeType);
                        !!req.expiryDates &&
                            url.searchParams.append("expiryDates", req.expiryDates);
                        !!req.strikePrices &&
                            url.searchParams.append("strikePrices", req.strikePrices);
                        !!req.optionTypes &&
                            url.searchParams.append("optionTypes", req.optionTypes);
                        !!req.assetsFlag && url.searchParams.append("assetsFlag", req.assetsFlag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        comSearch = _a.sent();
                        comfut = __assign(__assign({}, comSearch), { data: __assign(__assign({}, comSearch.data), { ComFut: comSearch.data.commodities }) });
                        return [2 /*return*/, comfut.data];
                }
            });
        });
    };
    SearchRepository.prototype.getCommOptSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, request, comSearch, comOpt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.comopt);
                        request = {
                            searchText: req.searchText,
                            pageNumber: req.pageNumber,
                            pageSize: req.pageSize,
                            expiryDates: req.expiryDates && [req.expiryDates],
                            exchange: req.exchangeType,
                            strikePrices: req.strikePrices && [req.strikePrices],
                            optionTypes: req.optionTypes && [req.optionTypes],
                            underlyings: req.underlyings && [req.underlyings],
                        };
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: request,
                            })];
                    case 1:
                        comSearch = _a.sent();
                        comOpt = __assign(__assign({}, comSearch), { data: __assign(__assign({}, comSearch.data), { ComOpt: comSearch.data.commodities }) });
                        return [2 /*return*/, comOpt.data];
                }
            });
        });
    };
    SearchRepository.prototype.getPrimaryMarket = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, pmSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.pmSearch);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        !!req.marketType && url.searchParams.append("marketTypes", req.marketType);
                        !!req.assetsFlag && url.searchParams.append("assetsFlag", req.assetsFlag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        pmSearch = _a.sent();
                        return [2 /*return*/, pmSearch.data];
                }
            });
        });
    };
    SearchRepository.prototype.getCurSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, cuSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.cuSearch);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        !!req.category && url.searchParams.append("category", req.category);
                        !!req.expiryDates &&
                            url.searchParams.append("expiryDates", req.expiryDates);
                        !!req.strikePrices &&
                            url.searchParams.append("strikePrices", req.strikePrices);
                        !!req.optionTypes &&
                            url.searchParams.append("optionTypes", req.optionTypes);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        cuSearch = _a.sent();
                        return [2 /*return*/, cuSearch.data];
                }
            });
        });
    };
    SearchRepository.prototype.getTrending = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, loginType, genTrending;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.genTrending);
                        if (!!req.trendingAssetType) {
                            url.searchParams.append("assetType", req.trendingAssetType);
                        }
                        if (!!req.recentSymbols)
                            url.searchParams.append("recentSymbols", req.recentSymbols);
                        !!req.accountId && url.searchParams.append("accountId", req.accountId);
                        return [4 /*yield*/, accountDetails.getUserLoginType()];
                    case 1:
                        loginType = _a.sent();
                        url.searchParams.append("loginType", loginType);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        genTrending = _a.sent();
                        return [2 /*return*/, genTrending.data];
                }
            });
        });
    };
    SearchRepository.prototype.saveTrending = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, loginType, genTrending;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.saveTrending + "/" + req.symbol);
                        url.searchParams.append("assetType", req.assetType);
                        !!req.accountId && url.searchParams.append("accountId", req.accountId);
                        return [4 /*yield*/, accountDetails.getUserLoginType()];
                    case 1:
                        loginType = _a.sent();
                        url.searchParams.append("loginType", loginType);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                            })];
                    case 2:
                        genTrending = _a.sent();
                        return [2 /*return*/, genTrending];
                }
            });
        });
    };
    SearchRepository.prototype.getEqSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, eqSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.eqSearch);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        !!req.exchangeType &&
                            url.searchParams.append("exchanges", req.exchangeType.toString());
                        !!req.assetsFlag && url.searchParams.append("assetsFlag", req.assetsFlag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        eqSearch = _a.sent();
                        return [2 /*return*/, eqSearch.data];
                }
            });
        });
    };
    SearchRepository.prototype.getFuSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, fuSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.fuSearch);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        !!req.assetsFlag && url.searchParams.append("assetsFlag", req.assetsFlag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        fuSearch = _a.sent();
                        return [2 /*return*/, fuSearch.data];
                }
            });
        });
    };
    SearchRepository.prototype.getOpSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, opSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.opSearch);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.underlyings &&
                            url.searchParams.append("underlyings", req.underlyings);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        !!req.expiryDates &&
                            url.searchParams.append("expiryDates", req.expiryDates);
                        !!req.strikePrices &&
                            url.searchParams.append("strikePrices", req.strikePrices);
                        !!req.optionTypes &&
                            url.searchParams.append("optionTypes", req.optionTypes);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        opSearch = _a.sent();
                        return [2 /*return*/, opSearch.data];
                }
            });
        });
    };
    SearchRepository.prototype.getCommSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, comSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.comSearch);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        !!req.assetsFlag && url.searchParams.append("assetsFlag", req.assetsFlag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        comSearch = _a.sent();
                        return [2 /*return*/, comSearch.data];
                }
            });
        });
    };
    SearchRepository.prototype.getETFSSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, etfsSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.etfsSearch);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        !!req.assetsFlag && url.searchParams.append("assetsFlag", req.assetsFlag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        etfsSearch = _a.sent();
                        return [2 /*return*/, etfsSearch.data];
                }
            });
        });
    };
    SearchRepository.prototype.getIndicesSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, indSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.indSearch);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        !!req.assetsFlag && url.searchParams.append("assetsFlag", req.assetsFlag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        indSearch = _a.sent();
                        return [2 /*return*/, indSearch.data];
                }
            });
        });
    };
    SearchRepository.prototype.getNCDSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, ncdsSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.ncdsSearch);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        !!req.assetsFlag && url.searchParams.append("assetsFlag", req.assetsFlag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        ncdsSearch = _a.sent();
                        return [2 /*return*/, ncdsSearch.data];
                }
            });
        });
    };
    SearchRepository.prototype.getMFSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, url, mfSearch, mutualFunds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = new Headers();
                        headers.append("ApiKey", process.env.ELASTIC_SEARCH_CONFIG);
                        url = new URL(searchConfigURL.mfSearchNew);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        !!req.category && url.searchParams.append("category", req.category);
                        !!req.assetsFlag && url.searchParams.append("assetsFlag", req.assetsFlag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                headers: headers,
                            })];
                    case 1:
                        mfSearch = _a.sent();
                        mutualFunds = !isEmpty(mfSearch.data.product_details)
                            ? mfSearch.data.product_details
                            : [];
                        mfSearch = __assign(__assign({}, mfSearch), { data: __assign(__assign({}, mfSearch.data), { mutualFunds: mutualFunds }) });
                        return [2 /*return*/, mfSearch.data];
                }
            });
        });
    };
    SearchRepository.prototype.getSGBSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, sgbSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.sgbSearch);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        sgbSearch = _a.sent();
                        return [2 /*return*/, sgbSearch.data];
                }
            });
        });
    };
    SearchRepository.prototype.getCorpFdSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, corpFdSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.corpFdSearch);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        corpFdSearch = _a.sent();
                        return [2 /*return*/, corpFdSearch.data];
                }
            });
        });
    };
    SearchRepository.prototype.getGeneralSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, genSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.genSearch);
                        url.searchParams.append("searchText", req.searchText);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        genSearch = _a.sent();
                        return [2 /*return*/, genSearch.data];
                }
            });
        });
    };
    SearchRepository.prototype.getOptionChainToolData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, optionChainTool;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.optionChainTool);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.assetTypes && url.searchParams.append("assetTypes", req.assetTypes);
                        !!req.assetsFlag && url.searchParams.append("assetsFlag", req.assetsFlag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        optionChainTool = _a.sent();
                        return [2 /*return*/, optionChainTool.data];
                }
            });
        });
    };
    SearchRepository.prototype.getWLSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, searchData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.wlSearch);
                        url.searchParams.append("searchText", req.searchText);
                        url.searchParams.append("module", "Watchlist");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        searchData = _a.sent();
                        return [2 /*return*/, searchData];
                }
            });
        });
    };
    SearchRepository.prototype.getFaqSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, faqSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.faqSearch);
                        url.searchParams.append("searchText", req.searchText);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        faqSearch = _a.sent();
                        return [2 /*return*/, faqSearch];
                }
            });
        });
    };
    SearchRepository.prototype.deleteRecentList = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, deleteRecent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.deleteRecent);
                        !!req.accountId && url.searchParams.append("accountId", req.accountId);
                        !!req.assetType && url.searchParams.append("assetType", req.assetType);
                        !!req.symbol && url.searchParams.append("symbol", req.symbol);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "DELETE",
                                url: url.toString(),
                            })];
                    case 1:
                        deleteRecent = _a.sent();
                        return [2 /*return*/, deleteRecent];
                }
            });
        });
    };
    SearchRepository.prototype.getCurFutSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, curSearch, curFut;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.curFut);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        !!req.assetsFlag && url.searchParams.append("assetsFlag", req.assetsFlag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        curSearch = _a.sent();
                        curFut = __assign(__assign({}, curSearch), { data: __assign(__assign({}, curSearch.data), { curFut: curSearch.data.currencies }) });
                        return [2 /*return*/, curFut.data];
                }
            });
        });
    };
    SearchRepository.prototype.getCurOptSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, curSearch, curOpt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.curOpt);
                        url.searchParams.append("searchText", req.searchText);
                        !!req.pageNumber &&
                            url.searchParams.append("pageNumber", req.pageNumber.toString());
                        !!req.pageSize &&
                            url.searchParams.append("pageSize", req.pageSize.toString());
                        !!req.expiryDates &&
                            url.searchParams.append("expiryDates", req.expiryDates);
                        !!req.strikePrices &&
                            url.searchParams.append("strikePrices", req.strikePrices);
                        !!req.optionTypes &&
                            url.searchParams.append("optionTypes", req.optionTypes);
                        !!req.underlyings &&
                            url.searchParams.append("underlyings", req.underlyings);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        curSearch = _a.sent();
                        curOpt = __assign(__assign({}, curSearch), { data: __assign(__assign({}, curSearch.data), { curOpt: curSearch.data.currencies }) });
                        return [2 /*return*/, curOpt.data];
                }
            });
        });
    };
    SearchRepository.prototype.putAllRecentList = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, putAllRecent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(searchConfigURL.putAllRecent);
                        !!req.accountId && url.searchParams.append("accountId", req.accountId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "PUT",
                                url: url.toString(),
                                body: req.recentSymbols,
                            })];
                    case 1:
                        putAllRecent = _a.sent();
                        return [2 /*return*/, putAllRecent];
                }
            });
        });
    };
    return SearchRepository;
}());
export default SearchRepository;
